function productsCategoriesSlider() {
  const sliders = document.querySelectorAll(
    ".products-tabs__content-wrapper .splide"
  );

  if (!sliders.length) return;

  sliders.forEach(el => {
    // Prevent double initialization
    if (el.dataset.splideInitialized === "true") return;

    const options = {
      type: "slide",
      autoWidth: false,
      perPage: 1,
      perMove: 1,
      gap: 16,
      mediaQuery: "min",
      pagination: false,
      speed: 500,
      keyboard: true,
      breakpoints: {
        992: {
          gap: 24,
          perPage: 4,
          perMove: 1
        }
      }
    };

    try {
      new Splide(el, options).mount();
      el.dataset.splideInitialized = "true";
    } catch (e) {
      // Fail gracefully without breaking the rest of the page
      console.error("[product-categories] Failed to initialize Splide:", e);
    }
  });
}

function productsTabsSimpleSwitch() {
  const groups = document.querySelectorAll(".products-tabs__labels");

  if (!groups.length) return;

  groups.forEach(labels => {
    const items = Array.from(labels.querySelectorAll("li"));

    if (!items.length) return;

    const row = labels.closest(".row");
    const wrapper = row
      ? row.querySelector(".products-tabs__content-wrapper")
      : null;

    if (!wrapper) return;

    const panels = Array.from(
      wrapper.querySelectorAll(".products-tabs__content")
    );

    // Ensure panels have proper ARIA and initial display state
    panels.forEach((panel, i) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute(
        "aria-hidden",
        panel.classList.contains("is-active") ? "false" : "true"
      );
      if (panel.classList.contains("is-active")) {
        panel.removeAttribute("hidden");
        panel.style.display = "";
      } else {
        panel.setAttribute("hidden", "");
        panel.style.display = "none";
      }
    });

    const activate = (index, shouldFocus = true) => {
      items.forEach((li, i) => {
        const btn = li.querySelector("button") || li;

        // Ensure each control has role=tab
        if (btn && btn.getAttribute("role") !== "tab") {
          btn.setAttribute("role", "tab");
        }

        if (i === index) {
          li.classList.add("is-active");
          btn.setAttribute("aria-selected", "true");
          btn.setAttribute("tabindex", "0");
          // focus the active control for keyboard users
          if (shouldFocus) {
            btn.focus();
          }
        } else {
          li.classList.remove("is-active");
          btn.setAttribute("aria-selected", "false");
          btn.setAttribute("tabindex", "-1");
        }
      });

      panels.forEach((panel, i) => {
        if (i === index) {
          panel.classList.add("is-active");
          panel.removeAttribute("hidden");
          panel.style.display = "";
          panel.setAttribute("aria-hidden", "false");
        } else {
          panel.classList.remove("is-active");
          panel.setAttribute("hidden", "");
          panel.style.display = "none";
          panel.setAttribute("aria-hidden", "true");
        }
      });
    };

    let initial = items.findIndex(
      li =>
        li.classList.contains("is-active") || li.classList.contains("active")
    );

    if (initial < 0) initial = 0;

    activate(initial, false);

    items.forEach((li, idx) => {
      const target = li.querySelector("button") || li;

      // Click handler
      target.addEventListener("click", e => {
        e.preventDefault();
        if (li.classList.contains("is-active")) return;
        activate(idx);
      });

      // Keyboard navigation: Left/Right, Home, End
      target.addEventListener("keydown", e => {
        const key = e.key;

        if (key === "ArrowRight" || key === "Right") {
          e.preventDefault();
          const next = (idx + 1) % items.length;

          activate(next);
        } else if (key === "ArrowLeft" || key === "Left") {
          e.preventDefault();
          const prev = (idx - 1 + items.length) % items.length;

          activate(prev);
        } else if (key === "Home") {
          e.preventDefault();
          activate(0);
        } else if (key === "End") {
          e.preventDefault();
          activate(items.length - 1);
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function() {
  productsTabsSimpleSwitch();
  productsCategoriesSlider();
});
